import { useQuery } from 'react-query';
import { client } from 'utils/api-client';

export default function useMinistries(params) {
  return useQuery('ministries', () =>
    client('ministry', { params }).then((res) => res)
  );
}
